import { Timestamp } from '@angular/fire/firestore';

export interface Prayer {
  id: string;
  groupId: string;
  category: string | undefined;
  created: Timestamp;
  modified: Timestamp;
  expiry: Timestamp;
  requestedBy: string | undefined;
  requestedById: string | undefined;
  approvedBy: string | undefined;
  approvedById: string | undefined;
  subject: string;
  description: string;
  updates: PrayerUpdate[];
  status: PrayerStatus;
}

export enum PrayerStatus {
  active = 'active',
  request = 'request',
  rejected = 'rejected',
  closed = 'closed',
  unknown = 'unknown',
}

export interface PrayerUpdate {
  status: string;
  updatedOn: Timestamp;
}
